// (() => {
//   if (customElements.get('product-media')) {
//     return;
//   }

//   class ProductMedia extends HTMLElement {
//     constructor() {
//       super();

//       this.selectors = {
//         mainSlider: '[data-main-product-slider]',
//         thumbsSlider: '[data-main-product-thumbs]',
//         progressBar: '[data-main-product-slider-progress-bar]',
//         modalOpeners: '[data-modal-opener-id]',
//         zoomImages: '[data-pswp-image]',
//         btnXr: '[data-shopify-xr]',
//         deferredMedia: 'deferred-media[data-autoplay]',
//         iframe: 'iframe',
//         youtube: '.js-youtube',
//         vimeo: '.js-vimeo',
//         closeIcon: '[data-close-icon]',
//         prevIcon: '[data-prev-icon]',
//         nextIcon: '[data-next-icon]',
//         thumbNextButton: '[data-thumbs-next]',
//         thumbPrevButton: '[data-thumbs-prev]',
//         mobileNavigation: '.main-product__media-controls-mobile-navigation'
//       };

//       this.mainSliderElement = this.querySelector(this.selectors.mainSlider);
//       this.mainSliderDrag = Number(this.mainSliderElement.dataset.slidesCount) !== 1;
//       this.autoHeight = this.hasAttribute('data-autoheight');

//       this.mainSliderMobileLayout = document.querySelector('.main-product__media-mobile-carousel');

//       var mainSliderPerView = 1;
//       var mainSliderSpacing = 0;

//       if(this.mainSliderMobileLayout) {
//         var mainSliderPerView = 1.1;
//         var mainSliderSpacing = 4;
//       }

//       this.settings = {
//         mainSlider: {
//           element: this.mainSliderElement,
//           instance: null,
//           options: {
//             loop: true,
//             spaceBetween: mainSliderSpacing,
//             slidesPerView: mainSliderPerView,
//             pagination: {
//               el: '.main-product__media-progress',
//               type: "progressbar",
//             },
//             allowTouchMove: this.mainSliderDrag,
//             autoHeight: this.autoHeight,
//             watchSlidesVisibility: true,
//             watchSlidesProgress: true,
//             breakpoints: {
//               990: {
//                 slidesPerView: 1,
//                 spaceBetween: 0
//               }
//             },
//             thumbs: {
//               swiper: null
//             }
//           }
//         },
//         thumbsSlider: {
//           element: this.querySelector(this.selectors.thumbsSlider),
//           instance: null,
//           options: {
//             spaceBetween: 4,
//             slidesPerView: 'auto',
//             direction: 'horizontal',
//             loop: false,
//             freeMode: true,
//             watchSlidesProgress: true,
//             centeredSlides: true,
//             slideToClickedSlide: true,
//             centerInsufficientSlides: true,
//             centeredSlidesBounds: true,
//             breakpoints: {
//               990: {
//                 spaceBetween: 16,
//                 slidesPerView: 4,
//                 direction: 'vertical'
//               }
//             },
//             navigation: {
//               nextEl: this.querySelector(this.selectors.thumbNextButton),
//               prevEl: this.querySelector(this.selectors.thumbPrevButton),
//             },
//             on: {
//               init: function(swiper) {
//                 const handleFirstSlides = () => {
//                   if (swiper.activeIndex <= 1) {
//                     setTimeout(() => {
//                       swiper.el.querySelector('.swiper-wrapper').style.transform = 'translate3d(0px, 0px, 0px)';
//                     }, 0);
//                   }
//                 };

//                 handleFirstSlides();

//                 swiper.on('slideChange', handleFirstSlides);
//                 swiper.on('resize', handleFirstSlides);
//                 swiper.on('transitionEnd', handleFirstSlides);
//               }
//             }
//           }
//         }
//       };

//       window.addEventListener('DOMContentLoaded', this.initSlider.bind(this));
//       window.addEventListener('resize', this.initSlider.bind(this));
//     }

//     connectedCallback() {
//       this.initSlider();

//       document.body.addEventListener('touchstart', () => {
//         this.querySelectorAll(this.selectors.deferredMedia).forEach((media) => {
//           const iframe = media.querySelector(this.selectors.iframe);

//           if (!iframe) return;

//           if (iframe.classList.contains('js-youtube')) {
//             iframe.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
//           }

//           if (iframe.classList.contains('js-vimeo')) {
//             iframe.contentWindow.postMessage('{"method":"play"}', '*');
//           }
//         })
//       }, { once: true });

//       this.initPhotoSwipe();
//     }

//     initSlider() {
//       if (window.innerWidth >= 990 && !this.mainSliderElement.hasAttribute('data-main-slider-desktop')) {
//         this.mainSliderElement.classList.add('is-initialized');

//         if (this.settings.mainSlider.instance) {
//           this.settings.mainSlider.instance.destroy(true, true);
//           this.settings.mainSlider.instance = null;
//         }

//         return;
//       }

//       if (this.settings.mainSlider.instance) {
//         return;
//       }

//       if (this.settings.thumbsSlider.element) {
//         this.settings.thumbsSlider.instance = new Swiper(
//           this.settings.thumbsSlider.element,
//           this.settings.thumbsSlider.options
//         );
//       }

//       this.settings.mainSlider.instance = new Swiper(
//         this.settings.mainSlider.element,
//         {
//           ...this.settings.mainSlider.options,
//           navigation: {
//             nextEl: '.main-product__media-next',
//             prevEl: '.main-product__media-prev'
//           },
//           thumbs: {
//             swiper: this.settings.thumbsSlider.instance
//           },
//           on: {
//             init: (swiper) => {
//               if (document.querySelector(this.selectors.mobileNavigation)) {
//                 const counterElement = document.querySelector('.main-product__media-counter');
//                 if (counterElement) {
//                   const currentSlideElement = counterElement.querySelector('#main-product__current-slide');
//                   const totalSlidesElement = counterElement.querySelector('#main-product__total-slides');

//                   const updateSlideCounter = () => {
//                     currentSlideElement.textContent = swiper.realIndex + 1;
//                     totalSlidesElement.textContent = swiper.slides.length;
//                   };

//                   updateSlideCounter();
//                   swiper.on('slideChange', updateSlideCounter);
//                 }
//               }
//             }
//           }
//         }
//       );

//       // Watch for changes in the main slider and update the thumb slider
//       this.settings.mainSlider.instance.on('slideChange', () => {
//         const index = this.settings.mainSlider.instance.realIndex;
//         if (this.settings.thumbsSlider.instance) {
//           this.settings.thumbsSlider.instance.slideTo(index);

//           this.updateThumbActiveClass(index);
//         }
//       });

//       // Watch for changes in the thumb slider and update the main slider
//       if (this.settings.thumbsSlider.instance) {
//         this.settings.thumbsSlider.instance.on('click', (swiper) => {
//           const clickedIndex = swiper.clickedIndex;
//           if (typeof clickedIndex !== 'undefined' && clickedIndex !== null) {
//             this.settings.mainSlider.instance.slideToLoop(clickedIndex);

//             this.updateThumbActiveClass(clickedIndex);
//           }
//         });
//       }

//       if (this.autoHeight) {
//         this.settings.mainSlider.instance.on('slideChangeTransitionEnd', () => {
//           this.changeListHeight(
//             this.settings.mainSlider.instance.el,
//             this.settings.mainSlider.instance.slides
//           );
//         });
//       }
//     }

//     updateThumbActiveClass(activeIndex) {
//       const thumbSlides = this.settings.thumbsSlider.element.querySelectorAll('.swiper-slide');
//       thumbSlides.forEach(slide => slide.classList.remove('swiper-slide-active'));
//       if (thumbSlides[activeIndex]) {
//         thumbSlides[activeIndex].classList.add('swiper-slide-active');
//       }
//     }

//     changeListHeight(rootEl, slides) {
//       rootEl.querySelector('.swiper-wrapper').style.height =
//         `${slides[this.settings.mainSlider.instance.realIndex].offsetHeight}px`;
//     }

//     goToSlide(mediaId) {
//       if (!this.settings.mainSlider.instance) {
//         const media = this.settings.mainSlider.element.querySelector(`[data-media-id="${mediaId}"]`);

//         if (!media) {
//           return;
//         }

//         media.scrollIntoView({
//           behavior: 'smooth'
//         });

//         return;
//       }

//       const slideIndex = Array.from(this.settings.mainSlider.instance.slides).findIndex((slide) => (
//         Number(slide.dataset.mediaId) === mediaId
//       ));

//       this.settings.mainSlider.instance.slideTo(slideIndex);
//     }

//     initPhotoSwipe() {
//       const [
//         zoomContainerWidth,
//         zoomContainerHeight,
//         closeIcon,
//         prevIcon,
//         nextIcon
//       ] = [
//         this.offsetWidth,
//         this.offsetHeight,
//         this.querySelector(this.selectors.closeIcon),
//         this.querySelector(this.selectors.prevIcon),
//         this.querySelector(this.selectors.nextIcon)
//       ];

//       const isPhone = () => window.innerWidth < 750;

//       const photoSwipeLightboxInstance = new PhotoSwipeLightbox({
//         gallery: `#${this.settings.mainSlider.element.id}`,
//         children: 'a',
//         mainClass: 'pswp--product-media-gallery',
//         loop: false,
//         showHideAnimationType: 'zoom',
//         initialZoomLevel: zoomLevelObject => isPhone() ? zoomLevelObject.vFill : zoomLevelObject.fit,
//         secondaryZoomLevel: zoomLevelObject => isPhone() ? zoomLevelObject.fit : 1,
//         pswpModule: PhotoSwipe
//       });

//       photoSwipeLightboxInstance.addFilter('itemData', (itemData, index) => {
//         if (itemData.type === 'html' && itemData.element) {
//           return { html: itemData.element.dataset.pswpHtml };
//         }
//         return itemData;
//       });

//       photoSwipeLightboxInstance.init();

//       photoSwipeLightboxInstance.on('beforeOpen', () => {
//         const videos = this.querySelectorAll('video');
//         Array.from(videos).forEach(video => {
//           video.play().then(() => {
//             // Automatic playback started!
//           }).catch(error => {
//             video.pause();
//           });
//         });
//       });
//     }
//   }

//   customElements.define('product-media', ProductMedia);

// })();


// custom code
(() => {
  if (customElements.get('product-media')) {
    return;
  }

  class ProductMedia extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        mainSlider: '[data-main-product-slider]',
        thumbsSlider: '[data-main-product-thumbs]',
        progressBar: '[data-main-product-slider-progress-bar]',
        modalOpeners: '[data-modal-opener-id]',
        zoomImages: '[data-pswp-image]',
        btnXr: '[data-shopify-xr]',
        deferredMedia: 'deferred-media[data-autoplay]',
        iframe: 'iframe',
        youtube: '.js-youtube',
        vimeo: '.js-vimeo',
        closeIcon: '[data-close-icon]',
        prevIcon: '[data-prev-icon]',
        nextIcon: '[data-next-icon]',
        thumbNextButton: '[data-thumbs-next]',
        thumbPrevButton: '[data-thumbs-prev]',
        mobileNavigation: '.main-product__media-controls-mobile-navigation'
      };

      this.mainSliderElement = this.querySelector(this.selectors.mainSlider);
      this.mainSliderDrag = Number(this.mainSliderElement.dataset.slidesCount) !== 1;
      this.autoHeight = this.hasAttribute('data-autoheight');

      this.mainSliderMobileLayout = document.querySelector('.main-product__media-mobile-carousel');

      var mainSliderPerView = 1;
      var mainSliderSpacing = 0;

      if (this.mainSliderMobileLayout) {
        var mainSliderPerView = 1.1;
        var mainSliderSpacing = 4;
      }

      this.settings = {
        mainSlider: {
          element: this.mainSliderElement,
          instance: null,
          options: {
            loop: true,
            spaceBetween: mainSliderSpacing,
            slidesPerView: mainSliderPerView,
            pagination: {
              el: '.main-product__media-progress',
              type: 'progressbar'
            },
            allowTouchMove: this.mainSliderDrag,
            autoHeight: this.autoHeight,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            breakpoints: {
              990: {
                slidesPerView: 1,
                spaceBetween: 0
              }
            }
          }
        },
        thumbsSlider: {
          element: this.querySelector(this.selectors.thumbsSlider),
          instance: null,
          options: {
            spaceBetween: 4,
            slidesPerView: 'auto',
            direction: 'horizontal',
            loop: false,
            freeMode: true,
            watchSlidesProgress: true,
            centeredSlides: true,
            slideToClickedSlide: true,
            centerInsufficientSlides: true,
            centeredSlidesBounds: true,
            breakpoints: {
              990: {
                spaceBetween: 16,
                slidesPerView: 4,
                direction: 'vertical'
              }
            },
            navigation: {
              nextEl: this.querySelector(this.selectors.thumbNextButton),
              prevEl: this.querySelector(this.selectors.thumbPrevButton)
            },
            on: {
              init: function (swiper) {
                const handleFirstSlides = () => {
                  if (swiper.activeIndex <= 1) {
                    setTimeout(() => {
                      swiper.el.querySelector('.swiper-wrapper').style.transform = 'translate3d(0px, 0px, 0px)';
                    }, 0);
                  }
                };

                handleFirstSlides();

                swiper.on('slideChange', handleFirstSlides);
                swiper.on('resize', handleFirstSlides);
                swiper.on('transitionEnd', handleFirstSlides);
              }
            }
          }
        }
      };

      window.addEventListener('DOMContentLoaded', this.initSlider.bind(this));
      window.addEventListener('resize', this.initSlider.bind(this));
    }

    connectedCallback() {
      // Filter before the first initSlider() so Swiper is built against the
      // correct slide set on landings that already carry a ?variant= selection.
      const didFilter = this.applyInitialVariantFilter();

      this.initSlider();

      // HERO MEDIA START
      // Only when the merchant enabled "position 1 image visible if no grouping
      // tag". With it on, media renders in the merchant's order rather than
      // with the selected variant's image hoisted first, so index 0 of the
      // filtered set is no longer guaranteed to be a visible slide. Needs the
      // Swiper instance, so it runs after initSlider() rather than inside the
      // filter call. With the setting off the Liquid hoist is back and this is
      // skipped, reproducing the original behaviour exactly.
      // To revert: delete this block and change the applyInitialVariantFilter()
      // call above back to `this.applyInitialVariantFilter();` (no const).
      if (didFilter && this.hasAttribute('data-hero-media-first')) {
        this.showFirstVisibleSlide();
      }
      // HERO MEDIA END

      document.body.addEventListener(
        'touchstart',
        () => {
          this.querySelectorAll(this.selectors.deferredMedia).forEach((media) => {
            const iframe = media.querySelector(this.selectors.iframe);

            if (!iframe) return;

            if (iframe.classList.contains('js-youtube')) {
              iframe.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
            }

            if (iframe.classList.contains('js-vimeo')) {
              iframe.contentWindow.postMessage('{"method":"play"}', '*');
            }
          });
        },
        { once: true }
      );

      this.initCustomGalleryModal();
    }

    initSlider() {
      if (window.innerWidth >= 990 && !this.mainSliderElement.hasAttribute('data-main-slider-desktop')) {
        this.mainSliderElement.classList.add('is-initialized');

        if (this.settings.mainSlider.instance) {
          this.settings.mainSlider.instance.destroy(true, true);
          this.settings.mainSlider.instance = null;
        }

        return;
      }

      if (this.settings.mainSlider.instance) {
        return;
      }

      if (this.settings.thumbsSlider.element) {
        this.settings.thumbsSlider.instance = new Swiper(this.settings.thumbsSlider.element, {
          ...this.settings.thumbsSlider.options,
          // Swiper's own click-to-slide moves the thumbs strip by index and, via
          // the thumbs module, used to drive the main slider too. We navigate by
          // media id in the click handler instead, so leaving this on means two
          // handlers fighting over one tap - which is what sent clicks to a
          // seemingly random image after a variant change.
          slideToClickedSlide: false
        });
      }

      this.settings.mainSlider.instance = new Swiper(this.settings.mainSlider.element, {
        ...this.settings.mainSlider.options,
        navigation: {
          nextEl: '.main-product__media-next',
          prevEl: '.main-product__media-prev'
        },
        // Deliberately NOT using Swiper's `thumbs` module. It pairs the two
        // sliders purely by index - it feeds the thumbs slider's clickedIndex
        // to the main slider's slideToLoop, and highlights thumbs via
        // `thumbSlides[mainSlider.realIndex]`. Those numberings drift apart once
        // a variant change re-inits the sliders and Swiper reassigns
        // data-swiper-slide-index, which made thumb clicks jump to the wrong
        // image. syncThumbToActiveSlide() and the click handler below do the
        // same job by media id, which survives re-init.
        on: {
          init: (swiper) => {
            if (document.querySelector(this.selectors.mobileNavigation)) {
              const counterElement = document.querySelector('.main-product__media-counter');
              if (counterElement) {
                const currentSlideElement = counterElement.querySelector('#main-product__current-slide');
                const totalSlidesElement = counterElement.querySelector('#main-product__total-slides');

                const updateSlideCounter = () => {
                  currentSlideElement.textContent = swiper.realIndex + 1;
                  totalSlidesElement.textContent = swiper.slides.length;
                };

                updateSlideCounter();
                swiper.on('slideChange', updateSlideCounter);
              }
            }
          }
        }
      });

      this.settings.mainSlider.instance.on('slideChange', () => {
        this.syncThumbToActiveSlide();
      });

      if (this.settings.thumbsSlider.instance) {
        // Replaces what Swiper's thumbs module used to do, but keyed on media id
        // rather than index. See the note on the main slider's config above.
        this.settings.thumbsSlider.instance.on('click', (swiper) => {
          const clickedThumb = swiper.clickedSlide;
          const mediaId = clickedThumb && clickedThumb.dataset.mediaId;

          if (!mediaId) {
            return;
          }

          this.goToSlide(mediaId);
          this.syncThumbToActiveSlide();
        });

        // The thumbs module used to set the initial highlight on init.
        this.syncThumbToActiveSlide();
      }

      if (this.autoHeight) {
        this.settings.mainSlider.instance.on('slideChangeTransitionEnd', () => {
          this.changeListHeight(this.settings.mainSlider.instance.el, this.settings.mainSlider.instance.slides);
        });
      }

      this.initCursorNavigation();
    }

    /**
     * Desktop slider layout: the left and right halves of the image navigate
     * back and forward, with a single arrow following the pointer to show which
     * way a click will go.
     *
     * Built once and reused, since initSlider() runs again on resize and after
     * every variant change.
     */
    initCursorNavigation() {
      if (!this.mainSliderElement || !this.mainSliderElement.hasAttribute('data-main-slider-desktop')) {
        return;
      }

      // A pointer that can hover is the whole premise; touch devices keep the
      // ordinary swipe plus corner buttons.
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        return;
      }

      if (this.cursorNavigationBuilt) {
        return;
      }

      // The existing corner buttons already carry translated labels in a
      // visually-hidden span; reuse those rather than hardcoding English.
      const labelFrom = (selector, fallback) => {
        const source = this.querySelector(`${selector} .visually-hidden`);
        const text = source && source.textContent.trim();

        return text || fallback;
      };

      const prevZone = document.createElement('button');
      prevZone.type = 'button';
      prevZone.className = 'main-product__media-nav-zone main-product__media-nav-zone--prev';
      prevZone.setAttribute('aria-label', labelFrom('.main-product__media-prev', 'Previous image'));

      const nextZone = document.createElement('button');
      nextZone.type = 'button';
      nextZone.className = 'main-product__media-nav-zone main-product__media-nav-zone--next';
      nextZone.setAttribute('aria-label', labelFrom('.main-product__media-next', 'Next image'));

      const cursor = document.createElement('div');
      cursor.className = 'main-product__media-cursor';
      cursor.setAttribute('aria-hidden', 'true');
      cursor.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
        'stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';

      this.mainSliderElement.append(prevZone, nextZone, cursor);

      // Flags hover on the slider so the Zoom badge can be revealed by class as
      // well as by the stylesheet's own :hover rule on the slide.
      this.mainSliderElement.addEventListener('mouseenter', () => {
        this.mainSliderElement.classList.add('is-media-hovered');
      });

      this.mainSliderElement.addEventListener('mouseleave', () => {
        this.mainSliderElement.classList.remove('is-media-hovered');
      });

      const setDirection = (isPrev) => {
        cursor.classList.toggle('main-product__media-cursor--prev', isPrev);
      };

      const moveCursor = (event) => {
        const rect = this.mainSliderElement.getBoundingClientRect();

        cursor.style.transform = `translate(${event.clientX - rect.left}px, ${event.clientY - rect.top}px)`;
      };

      [prevZone, nextZone].forEach((zone) => {
        const isPrev = zone === prevZone;

        zone.addEventListener('mouseenter', (event) => {
          setDirection(isPrev);
          moveCursor(event);
          cursor.classList.add('is-visible');
        });

        zone.addEventListener('mousemove', moveCursor);

        zone.addEventListener('mouseleave', () => {
          cursor.classList.remove('is-visible');
        });

        // The Zoom badge sits above the zones, so moving onto it fires
        // mouseleave here; hiding the arrow keeps the two from overlapping.
        zone.addEventListener('mouseout', (event) => {
          if (event.relatedTarget && event.relatedTarget.closest('.main-product__media-toggle-icon')) {
            cursor.classList.remove('is-visible');
          }
        });

        zone.addEventListener('click', () => {
          const swiper = this.settings.mainSlider.instance;

          if (!swiper) {
            return;
          }

          if (isPrev) {
            swiper.slidePrev();
          } else {
            swiper.slideNext();
          }
        });
      });

      this.cursorNavigationBuilt = true;
    }

    /**
     * Highlights the thumb matching the main slider's current slide, and
     * scrolls the thumbs strip to it.
     *
     * Matches on media id rather than index. The main slider carries loop
     * clones and the thumbs slider does not, and filtering hides slides in both
     * without removing them, so the two index spaces do not line up. Feeding the
     * main slider's realIndex to the thumbs slider (as this used to do) left the
     * highlighted thumb out of step with the image on screen, and could leave
     * the thumbs slider's own activeIndex wrong enough that Swiper swallowed
     * clicks on some thumbs.
     */
    syncThumbToActiveSlide() {
      const swiper = this.settings.mainSlider.instance;
      const thumbsElement = this.settings.thumbsSlider.element;

      if (!swiper || !thumbsElement) {
        return;
      }

      const activeSlide = swiper.slides[swiper.activeIndex];
      const mediaId = activeSlide && activeSlide.dataset.mediaId;
      const thumbSlides = Array.from(thumbsElement.querySelectorAll('.swiper-slide'));

      // swiper-slide-thumb-active is what the stylesheet keys the active thumb
      // border off; swiper-slide-active is kept in step for anything else
      // reading it. Both were previously set by Swiper's thumbs module.
      thumbSlides.forEach((slide) => {
        slide.classList.remove('swiper-slide-thumb-active');
        slide.classList.remove('swiper-slide-active');
      });

      if (!mediaId) {
        return;
      }

      // Scroll the thumbs strip using the thumbs slider's OWN index for that
      // media id, never the main slider's.
      const thumbsInstance = this.settings.thumbsSlider.instance;

      if (thumbsInstance) {
        const thumbIndex = Array.from(thumbsInstance.slides || []).findIndex(
          (slide) => String(slide.dataset.mediaId) === String(mediaId)
        );

        // Only scroll when the thumb is off screen. The strip runs with
        // centeredSlides, so an unconditional slideTo re-centres on the new
        // thumb and shifts the whole row sideways - very noticeable when the
        // thumbs all fit and no scrolling was needed. This mirrors the guard
        // Swiper's own thumbs module applies before it scrolls.
        const visibleIndexes = thumbsInstance.visibleSlidesIndexes;
        const alreadyVisible =
          Array.isArray(visibleIndexes) && visibleIndexes.indexOf(thumbIndex) >= 0;

        if (thumbIndex >= 0 && !alreadyVisible) {
          thumbsInstance.slideTo(thumbIndex);
        }
      }

      const match = thumbSlides.find(
        (slide) => String(slide.dataset.mediaId) === String(mediaId)
      );

      if (match) {
        match.classList.add('swiper-slide-thumb-active');
        match.classList.add('swiper-slide-active');
      }
    }

    changeListHeight(rootEl, slides) {
      const wrapper = rootEl.querySelector('.swiper-wrapper');

      if (!wrapper) {
        return;
      }

      // `slides` includes loop clones, so it must be indexed with activeIndex.
      // realIndex counts real slides only, which pointed one slide off (and at
      // the leading clone for the first slide).
      const activeSlide = slides[this.settings.mainSlider.instance.activeIndex];

      if (!activeSlide) {
        return;
      }

      wrapper.style.height = `${activeSlide.offsetHeight}px`;
    }

    goToSlide(mediaId) {
      if (!this.settings.mainSlider.instance) {
        const media = this.settings.mainSlider.element.querySelector(`[data-media-id="${mediaId}"]`);

        if (!media) {
          return;
        }

        media.scrollIntoView({
          behavior: 'smooth'
        });

        return;
      }

      const swiper = this.settings.mainSlider.instance;
      const slides = Array.from(swiper.slides);

      // Compare as strings: callers pass either a number (variant featured
      // media id) or a string (dataset value), and dataset is always a string.
      const slideIndex = slides.findIndex(
        (slide) => String(slide.dataset.mediaId) === String(mediaId)
      );

      if (slideIndex < 0) {
        return;
      }

      // With loop clones present, slideTo would target a duplicate; slideToLoop
      // works in real-slide numbering, which is what the id lookup gives us.
      if (swiper.params.loop && typeof swiper.slideToLoop === 'function') {
        const realIndex = Number(slides[slideIndex].dataset.swiperSlideIndex);

        swiper.slideToLoop(Number.isNaN(realIndex) ? slideIndex : realIndex);

        return;
      }

      swiper.slideTo(slideIndex);
    }

    /**
     * Applies filtering for the variant the page was rendered with, so a
     * ?variant= landing or a shared link arrives already filtered rather than
     * waiting for the shopper to touch the picker.
     */
    applyInitialVariantFilter() {
      if (!this.hasAttribute('data-variant-media-filtering') || !window.VariantMediaFilter) {
        return;
      }

      const variantId = this.dataset.selectedVariantId;

      if (!variantId) {
        return;
      }

      const visibleIds = window.VariantMediaFilter.resolve(this, variantId);

      window.VariantMediaFilter.apply(this, visibleIds);

      if (visibleIds !== null) {
        // Reflect the filtered count so Swiper's drag behaviour is right on init.
        this.mainSliderDrag = window.VariantMediaFilter.visibleCount(this) !== 1;
        this.settings.mainSlider.options.allowTouchMove = this.mainSliderDrag;
      }

      // HERO MEDIA START
      // Reports whether filtering applied, so connectedCallback knows to move
      // the slider onto the first visible slide. To revert: delete this return.
      return visibleIds !== null;
      // HERO MEDIA END
    }

    /**
     * Restricts the gallery to the media grouped with the selected variant.
     *
     * The group is the alt text of the variant's own assigned image: every image
     * sharing that alt text stays visible, alongside any image with no alt text,
     * which is treated as shared across all variants. Falls back to showing
     * everything when the variant has no assigned image, or that image has no
     * alt text to group by.
     *
     * Returns true when the gallery was actually narrowed, so the caller can
     * skip its scroll-to-slide step; false when it fell back to showing all.
     */
    filterByVariant(variantId) {
      if (!this.hasAttribute('data-variant-media-filtering') || !window.VariantMediaFilter) {
        return false;
      }

      const visibleIds = window.VariantMediaFilter.resolve(this, variantId);

      window.VariantMediaFilter.apply(this, visibleIds);
      this.refreshAfterFilter();

      // The zoom modal is built once and cached; the filtered set has changed,
      // so force it to rebuild from the now-visible media on next open.
      const modal = document.querySelector('product-media-gallery');

      if (modal) {
        modal.dataset.built = 'false';

        // Rebuilding replaces the modal's markup wholesale, which leaves these
        // Swiper instances pointing at elements that are no longer in the
        // document. Destroying one of those throws, and the exception would
        // abort the open, so drop the references here instead.
        this.destroyGallerySwipers();
      }

      return visibleIds !== null;
    }

    /**
     * Re-syncs the sliders with the current set of visible slides.
     *
     * Swiper runs with `loop: true`, which clones slides — updating in place
     * leaves stale clones behind, so the reliable fix is a full re-init. When
     * Swiper is destroyed (desktop grid/stack layout) the CSS class does all the
     * work and there is nothing to re-sync.
     */
    refreshAfterFilter() {
      const hasSwiper = Boolean(this.settings.mainSlider.instance);

      if (!hasSwiper) {
        return;
      }

      if (this.settings.mainSlider.instance) {
        this.settings.mainSlider.instance.destroy(true, true);
        this.settings.mainSlider.instance = null;
      }

      if (this.settings.thumbsSlider.instance) {
        this.settings.thumbsSlider.instance.destroy(true, true);
        this.settings.thumbsSlider.instance = null;
      }

      // Keep drag behaviour honest when filtering leaves a single slide.
      const visibleCount = window.VariantMediaFilter.visibleCount(this);

      this.mainSliderDrag = visibleCount !== 1;
      this.settings.mainSlider.options.allowTouchMove = this.mainSliderDrag;

      this.initSlider();
      this.showFirstVisibleSlide();
    }

    /**
     * Moves the slider onto the first slide that is actually visible.
     *
     * Swiper collects slides by class and ignores `display: none`, so hidden
     * ones still occupy positions in its index. After a re-init it restores the
     * previous active index, which may now point at a filtered-out slide -
     * leaving the viewport apparently blank until the shopper taps a thumbnail.
     */
    showFirstVisibleSlide() {
      const swiper = this.settings.mainSlider.instance;

      if (!swiper || !window.VariantMediaFilter) {
        return;
      }

      const hiddenClass = window.VariantMediaFilter.HIDDEN_CLASS;
      const slides = Array.from(swiper.slides || []);

      const targetIndex = slides.findIndex(
        (slide) =>
          !slide.classList.contains(hiddenClass) &&
          !slide.classList.contains('swiper-slide-duplicate')
      );

      if (targetIndex < 0) {
        return;
      }

      // slideToLoop indexes by real slide, which is what we want with loop
      // clones present; slideTo is correct when looping is off.
      if (swiper.params.loop && typeof swiper.slideToLoop === 'function') {
        const realIndex = Number(slides[targetIndex].dataset.swiperSlideIndex);

        swiper.slideToLoop(Number.isNaN(realIndex) ? targetIndex : realIndex, 0);

        return;
      }

      swiper.slideTo(targetIndex, 0);
    }

    initCustomGalleryModal() {
      const modal = document.querySelector('product-media-gallery');
      if (!modal) return;

      this.galleryMainSwiper = null;
      this.galleryThumbsSwiper = null;

      const productTitle = document.querySelector('.main-product__title')
        ? document.querySelector('.main-product__title').textContent.trim()
        : '';

      const buildModal = () => {
        if (modal.dataset.built === 'true') return;

        const items = [];
        // Only mirror media that is currently visible, so the zoom modal shows
        // the same set as the gallery when variant filtering is active.
        const hiddenClass = window.VariantMediaFilter
          ? window.VariantMediaFilter.HIDDEN_CLASS
          : 'is-variant-hidden';
        const allMedia = this.querySelectorAll(`[data-product-media]:not(.${hiddenClass})`);

        allMedia.forEach((mediaEl) => {
          const mediaId = mediaEl.dataset.mediaId;
          const img = mediaEl.querySelector('img');
          const video = mediaEl.querySelector('video');
          const iframe = mediaEl.querySelector('iframe');

          let slideHtml = '';
          let thumbHtml = '';

          if (img) {
            const fullSrc = img.dataset.src || img.src;
            const srcset = img.dataset.srcset || img.srcset || '';
            const altAttr = (img.alt || '').replace(/"/g, '&quot;');

            const magnifierEl = mediaEl.querySelector('image-magnifier');
            let imgMarkup = `<img src="${fullSrc}" srcset="${srcset}" alt="${altAttr}" />`;

            if (magnifierEl) {
              const magZoom = magnifierEl.dataset.magnifierZoom || '2.5';
              const magLensSize = magnifierEl.dataset.magnifierLensSize || '200';
              const magLensEnabled = magnifierEl.dataset.magnifierLensEnabled || 'true';
              const magMobile = magnifierEl.dataset.magnifierMobileEnabled || 'true';
              const magSrc = magnifierEl.dataset.magnifierSrc || fullSrc;
              const magW = magnifierEl.dataset.magnifierWidth || '';
              const magH = magnifierEl.dataset.magnifierHeight || '';

              const toggleMarkup = magMobile === 'true'
                ? `<button class="image-magnifier__toggle" type="button" aria-pressed="false" aria-label="Toggle image zoom">
                     <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                       <circle cx="10.5" cy="10.5" r="6.5" stroke="currentColor" stroke-width="1.6" fill="none"/>
                       <line x1="15.5" y1="15.5" x2="20" y2="20" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                       <line x1="10.5" y1="7.5" x2="10.5" y2="13.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                       <line x1="7.5" y1="10.5" x2="13.5" y2="10.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                     </svg>
                   </button>`
                : '';

              const lensMarkup = magLensEnabled === 'true'
                ? `<div class="image-magnifier__lens" aria-hidden="true" style="display:block;"></div>`
                : '';

              imgMarkup = `
                <image-magnifier
                  class="image-magnifier image-magnifier--modal"
                  data-magnifier-zoom="${magZoom}"
                  data-magnifier-lens-size="${magLensSize}"
                  data-magnifier-lens-enabled="${magLensEnabled}"
                  data-magnifier-mobile-enabled="${magMobile}"
                  data-magnifier-src="${magSrc}"
                  data-magnifier-width="${magW}"
                  data-magnifier-height="${magH}"
                >
                  <div class="image-magnifier__target">
                    <img src="${fullSrc}" srcset="${srcset}" alt="${altAttr}" />
                  </div>
                  ${lensMarkup}
                  ${toggleMarkup}
                </image-magnifier>
              `;
            }

            slideHtml = `
              <div class="bc-gallery-modal__slide-inner">
                ${imgMarkup}
              </div>
            `;
            thumbHtml = `<img src="${fullSrc}" alt="${altAttr}" />`;
          } else if (video) {
            const sources = video.querySelectorAll('source');
            let sourceTags = '';
            sources.forEach((s) => {
              sourceTags += `<source src="${s.src}" type="${s.type}">`;
            });
            const poster = video.poster || (img ? img.src : '');
            slideHtml = `
              <div class="bc-gallery-modal__slide-inner">
                <video controls playsinline ${poster ? `poster="${poster}"` : ''}>${sourceTags}</video>
              </div>
            `;
            thumbHtml = poster
              ? `<img src="${poster}" alt="" /><span class="bc-gallery-modal__thumb-icon">▶</span>`
              : `<span class="bc-gallery-modal__thumb-icon">▶</span>`;
          } else if (iframe) {
            slideHtml = `
              <div class="bc-gallery-modal__slide-inner">
                <iframe src="${iframe.src}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
              </div>
            `;
            thumbHtml = `<span class="bc-gallery-modal__thumb-icon">▶</span>`;
          }

          if (slideHtml) {
            items.push({ slideHtml, thumbHtml, mediaId });
          }
        });

        if (items.length === 0) return;

        const slidesMarkup = items
          .map((item) => `<div class="swiper-slide bc-gallery-modal__slide" data-media-id="${item.mediaId}">${item.slideHtml}</div>`)
          .join('');

        const thumbsMarkup = items
          .map(
            (item) =>
              `<div class="swiper-slide bc-gallery-modal__thumb" data-media-id="${item.mediaId}">${item.thumbHtml}</div>`
          )
          .join('');

        const modalContent = `
          <div class="bc-gallery-modal" role="dialog" aria-modal="true" tabindex="-1">
            <div class="bc-gallery-modal__header">
              <button type="button" class="bc-gallery-modal__back" aria-label="Back">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
                <span class="bc-gallery-modal__title">${productTitle}</span>
              </button>
              <button type="button" class="bc-gallery-modal__close" aria-label="Close">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
              </button>
            </div>

            <div class="bc-gallery-modal__body">
              <button type="button" class="bc-gallery-modal__nav bc-gallery-modal__nav--prev" aria-label="Previous">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
              </button>

              <div class="swiper bc-gallery-modal__main-swiper">
                <div class="swiper-wrapper">${slidesMarkup}</div>
              </div>

              <button type="button" class="bc-gallery-modal__nav bc-gallery-modal__nav--next" aria-label="Next">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
              </button>
            </div>

            <div class="bc-gallery-modal__footer">
              <div class="swiper bc-gallery-modal__thumbs-swiper">
                <div class="swiper-wrapper">${thumbsMarkup}</div>
              </div>
            </div>
          </div>
        `;

        modal.innerHTML = modalContent;
        modal.dataset.built = 'true';

        this.bindModalEvents(modal, items);
      };

      const openModal = (mediaId) => {
        buildModal();

        modal.setAttribute('open', '');
        document.body.style.overflow = 'hidden';

        setTimeout(() => {
          this.initGallerySwipers(modal);

          if (mediaId && this.galleryMainSwiper) {
            const targetIndex = Array.from(modal.querySelectorAll('.bc-gallery-modal__slide')).findIndex(
              (slide) => slide.dataset.mediaId === mediaId
            );
            if (targetIndex >= 0) {
              this.galleryMainSwiper.slideTo(targetIndex, 0);
            }
          }
        }, 50);
      };

      // Delegated rather than bound per element. Variant filtering detaches
      // slides and reattaches them later, and the initial filter runs before
      // this method, so binding to the triggers present right now would miss
      // every slide that is currently filtered out. Those triggers are anchors
      // pointing at the raw image with target="_blank", so a missing handler
      // means the browser just opens the file in a new tab.
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-pswp-image], [data-pswp-type="html"]');

        if (!trigger || !this.contains(trigger)) {
          return;
        }

        event.preventDefault();
        openModal(trigger.dataset.mediaId);
      });
    }

    bindModalEvents(modal, items) {
      const closeBtn = modal.querySelector('.bc-gallery-modal__close');
      const backBtn = modal.querySelector('.bc-gallery-modal__back');

      const closeModal = () => {
        modal.removeAttribute('open');
        document.body.style.overflow = '';

        modal.querySelectorAll('video').forEach((v) => v.pause());
        modal.querySelectorAll('iframe').forEach((iframe) => {
          const src = iframe.src;
          iframe.src = src;
        });
      };

      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (backBtn) backBtn.addEventListener('click', closeModal);

      // The modal is rebuilt whenever variant filtering changes the media set,
      // so replace the previous document-level listener instead of stacking one
      // up per rebuild.
      if (this.modalEscapeHandler) {
        document.removeEventListener('keydown', this.modalEscapeHandler);
      }

      this.modalEscapeHandler = (e) => {
        if (e.key === 'Escape' && modal.hasAttribute('open')) {
          closeModal();
        }
      };

      document.addEventListener('keydown', this.modalEscapeHandler);
    }

    /**
     * Tears down the zoom modal's sliders, tolerating instances whose elements
     * have already been removed from the document (which happens when the modal
     * markup is rebuilt after a variant change).
     */
    destroyGallerySwipers() {
      [this.galleryMainSwiper, this.galleryThumbsSwiper].forEach((instance) => {
        if (!instance || instance.destroyed) {
          return;
        }

        try {
          instance.destroy(true, true);
        } catch (error) {
          // Element already gone; nothing left to clean up.
        }
      });

      this.galleryMainSwiper = null;
      this.galleryThumbsSwiper = null;
    }

    initGallerySwipers(modal) {
      if (typeof Swiper === 'undefined') return;

      this.destroyGallerySwipers();

      const thumbsEl = modal.querySelector('.bc-gallery-modal__thumbs-swiper');
      const mainEl = modal.querySelector('.bc-gallery-modal__main-swiper');

      // buildModal() bails out when a variant resolves to no media, leaving the
      // modal without its markup. Nothing to initialise in that case.
      if (!thumbsEl || !mainEl) {
        return;
      }

      this.galleryThumbsSwiper = new Swiper(thumbsEl, {
        spaceBetween: 12,
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        centerInsufficientSlides: true,
        freeMode: true
      });

      this.galleryMainSwiper = new Swiper(mainEl, {
        spaceBetween: 0,
        slidesPerView: 1,
        navigation: {
          nextEl: modal.querySelector('.bc-gallery-modal__nav--next'),
          prevEl: modal.querySelector('.bc-gallery-modal__nav--prev')
        },
        thumbs: {
          swiper: this.galleryThumbsSwiper
        },
        keyboard: {
          enabled: true
        }
      });
    }
  }

  customElements.define('product-media', ProductMedia);
})();